export const getListError = (rejectObj) => {
    const tempErrorList = []
    for (const key in rejectObj) {
        tempErrorList.push(rejectObj[key].join(", "))
    }
    return tempErrorList
}